'use client'

import { Composite, CompositeItem } from '@floating-ui/react'
import { FC, cloneElement } from 'react'

import { CompositeHTMLProps, FILTER_ITEM_CLASS_NAME } from './constants'
import { FilterConfig } from './types'

type MainMenuProps = {
  filters: FilterConfig[]
  onSelect: (filter: FilterConfig) => void
}

export const MainMenu: FC<MainMenuProps> = ({ filters, onSelect }) => {
  return (
    <Composite
      orientation="vertical"
      className="flex flex-col gap-1 p-2"
      role="menu"
      aria-label="Filter options">
      {filters.map(filter => (
        <CompositeItem
          key={filter.key}
          render={(htmlProps: CompositeHTMLProps) => (
            <button
              {...htmlProps}
              className={FILTER_ITEM_CLASS_NAME}
              role="menuitem"
              onClick={() => onSelect(filter)}>
              {cloneElement(filter.icon, {
                size: 18,
                'aria-hidden': true,
                className: 'shrink-0'
              })}
              <span className="grow text-left">{filter.label}</span>
            </button>
          )}
        />
      ))}
    </Composite>
  )
}
